import { styled } from "@mui/system";
import { BooleanInput } from "react-admin";
export const GamespaceCheckbox = styled(BooleanInput)({
    marginBottom: "20px"
});
